import React, { useState } from 'react';

function Footer() {
  const [email, setEmail] = useState('');

  const handleSubscribe = (e) => {
    e.preventDefault();
    alert('Subscribed!');
    setEmail('');
  };

  return (
    <footer className="footer">
      <div className="map-section">
        <iframe 
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1299.4595698360267!2d73.08190322193!3d31.46961037817898!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3922420c69e5678b%3A0x98338d4b3bdbd16!2sFarhan%20Electronics!5e0!3m2!1sen!2s!4v1769798450034!5m2!1sen!2s" 
          width="100%" 
          height="400" 
          style={{border:0}} 
          allowFullScreen="" 
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      <div className="newsletter-section">
        <div className="newsletter-content">
          <h2>Subscribe Our Newsletter</h2>
          <form className="newsletter-form" onSubmit={handleSubscribe}>
            <input 
              type="email" 
              placeholder="Enter Email Address" 
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
            <button type="submit">Subscribe</button>
          </form>
        </div>
      </div>

      <div className="footer-main">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img 
                src="/logo.png" 
                alt="Loom Logo" 
                style={{height: '60px', width: 'auto', maxWidth: '200px', marginBottom: '15px'}}
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <h3 style={{display: 'none', color: '#ffc107', fontSize: '1.8rem', marginBottom: '15px'}}>LOOM PARTS</h3>
            </div>
            <p>Premium quality powerloom spare parts and machinery. We provide the best products at competitive prices for textile industry.</p>
            <div className="social-icons">
              <a href="#">f</a>
              <a href="#">t</a>
              <a href="#">g+</a>
              <a href="#">▶</a>
              <a href="#">📷</a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Useful Links</h4>
            <ul>
              <li>Site Map</li>
              <li>Search Terms</li>
              <li>Suppliers</li>
              <li>About Us</li>
              <li>Contact Us</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Category</h4>
            <ul>
              <li>Powerloom Parts</li>
              <li>Rapier Parts</li>
              <li>Airjet Parts</li>
              <li>Waterjet Parts</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>My Account</h4>
            <ul>
              <li>My account</li>
              <li>Checkout</li>
              <li>Login</li>
              <li>address</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Info</h4>
            <div className="contact-info-item">
              <span className="icon">📍</span>
              <span>Faisalabad, Pakistan</span>
            </div>
            <div className="contact-info-item">
              <span className="icon">✉</span>
              <span>info@loom.com</span>
            </div>
            <div className="contact-info-item">
              <span className="icon">📱</span>
              <span>03217600273</span>
            </div>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2024 All Rights Reserved by LOOM | Developed by Abdullah Arif | 📞 03137323866</p>
        <div className="payment-methods">
          <span className="payment-card">VISA</span>
          <span className="payment-card">DISCOVER</span>
          <span className="payment-card">MASTER</span>
          <span className="payment-card">PayPal</span>
          <span className="payment-card">AMEX</span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
